export default function Sort(options: any[]) {
  const sortedOptions = options.sort((a: any, b: any) =>
    a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 0
  );
  return sortedOptions;
}
